import { useTheme } from 'styled-components'

import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SortablePackagingListSkeleton = () => {
  const theme = useTheme()

  return (
    <div>
      {Array.from({ length: 5 }).map((_, index) => (
        <Styles.ItemContainer key={index} backgroundColor={index % 2 ? theme.colors.background.secondary : 'white'}>
          <Styles.IdentifierContainer>
            <Skeleton variant="text" width={30} height={20} />
          </Styles.IdentifierContainer>
          <Styles.InfoContainer>
            <Styles.Header>
              <Styles.NameContainer>
                <Skeleton variant="circular" width={24} height={24} />
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton variant="text" width={150} height={20} />
              </Styles.NameContainer>
              <Skeleton variant="rounded" width={24} height={24} />
            </Styles.Header>
            <Skeleton variant="text" width={200} height={16} />
          </Styles.InfoContainer>
        </Styles.ItemContainer>
      ))}
    </div>
  )
}

export default SortablePackagingListSkeleton
